import Immutable from 'immutable';
import { actionTypes } from './constants';

////////////////// EDIT //////////////////

export const $$initialState = Immutable.fromJS({
  createAlbumError: {},
  createPhotoError: {},
  // dev_tools_on: true,
  fetchAlbumsError: {},
  photoIsUploading: false,
  setIsSaving: false,
  setIsFetching: false,
  $$albums: Immutable.fromJS([]),
  $$photos: Immutable.fromJS([]),
  updateAlbumError: {},
});

////////////////// EDIT //////////////////

function appReducer($$state = $$initialState, action) {
  const { payload } = action;

  switch (action.type) {
    case actionTypes.CLEAR_ALBUM_MODAL_ERRORS:
      return $$state.merge(
        Immutable.fromJS({
          createAlbumError: {},
          updateAlbumError: {},
        })
      );

    case actionTypes.CREATE_ALBUM_SUCCESS:
      return (
        $$state
          // .updateIn(['$$albums'], $$albums => $$albums.push(Immutable.fromJS(payload.album)))
          .merge(
            Immutable.fromJS({
              setIsSaving: false,
              createAlbumError: {},
            })
          )
      );

    case actionTypes.CREATE_ALBUM_FAILURE:
      return $$state.merge(
        Immutable.fromJS({
          setIsSaving: false,
          createAlbumError: payload.error,
        })
      );

    case actionTypes.CREATE_PHOTO_SUCCESS:
      return $$state
        .updateIn(['$$photos'], $$photos =>
          $$photos.push(Immutable.fromJS(payload.photo))
        )
        .merge(
          Immutable.fromJS({
            photoIsUploading: false,
            createPhotoError: {},
          })
        );

    case actionTypes.CREATE_PHOTO_FAILURE:
      return $$state.merge(
        Immutable.fromJS({
          photoIsUploading: false,
          createPhotoError: payload.error,
        })
      );

    case actionTypes.DELETE_ALBUM_SUCCESS:
      return $$state
        .updateIn(['$$albums'], $$albums =>
          $$albums.delete(
            $$albums.findIndex($$album => $$album.get('id') === payload.id)
          )
        )
        .merge({
          setIsSaving: false,
        });

    case actionTypes.DELETE_PHOTO_SUCCESS:
      return $$state
        .updateIn(['$$photos'], $$photos =>
          $$photos.delete(
            $$photos.findIndex($$photo => $$photo.get('id') === payload.id)
          )
        )
        .merge({
          setIsSaving: false,
        });

    case actionTypes.FETCH_ALBUMS_SUCCESS:
      return $$state.merge(
        Immutable.fromJS({
          $$albums: payload.albums,
          fetchAlbumsError: {},
          setIsFetching: false,
        })
      );

    case actionTypes.FETCH_ALBUMS_FAILURE:
      return $$state.merge(
        Immutable.fromJS({
          fetchAlbumsError: payload.error,
          setIsFetching: false,
        })
      );

    case actionTypes.FETCH_PHOTOS_SUCCESS:
      return $$state.merge(
        Immutable.fromJS({
          $$photos: payload.photos,
          setIsFetching: false,
          photoIsUploading: false,
          fetchPhotosError: {},
        })
      );

    case actionTypes.PHOTO_IS_UPLOADING:
      return $$state.merge({
        photoIsUploading: true,
      });

    case actionTypes.SET_IS_FETCHING:
      return $$state.merge({
        setIsFetching: true,
      });

    case actionTypes.SET_IS_SAVING:
      return $$state.merge({
        setIsSaving: true,
      });

    case actionTypes.UPDATE_ALBUM_SUCCESS:
      return $$state
        .updateIn(['$$albums'], $$albums => {
          return $$albums.update(
            $$albums.findIndex(
              $$album => $$album.get('id') === payload.album.id
            ),
            $$album => Immutable.fromJS(payload.album)
          );
        })
        .merge(
          Immutable.fromJS({
            setIsSaving: false,
            updateAlbumError: {},
          })
        );

    case actionTypes.UPDATE_ALBUM_FAILURE:
      return $$state.merge(
        Immutable.fromJS({
          setIsSaving: false,
          updateAlbumError: payload.error,
        })
      );

    default:
      return $$state;
  }
}

////////////////// PERMANENT //////////////////

export default {
  $$appStore: appReducer,
};

export const initalStates = {
  $$initialState,
};
